<template>
  <div class="row vue-steps pl-0  pl-md-3 pr-0 pr-md-3 pl-lg-0">
    <div class="col-12 col-md-3 p-0">
      <a v-on:click="goToStepOne" class="w-100 stepLinkWrap">
        <StepElement stepName="stepOne" step-number="1"></StepElement>
      </a>
    </div>
    <div class="col-12 col-md-3 p-0">
      <a v-on:click="goToStepTwo" class="w-100 stepLinkWrap">
        <StepElement cssClass="step-center" step-number="2" stepName="stepTwo"/>
      </a>
    </div>
    <div class="col-12 col-md-3 p-0">
      <a v-on:click="goToStepThree" class="w-100 stepLinkWrap">
        <StepElement stepName="stepThree" css-class="step-center" step-number="3"></StepElement>
      </a>
    </div>
    <div class="col-12 col-md-3 p-0">
      <a v-on:click="goToStepFour" class="w-100 stepLinkWrap">
        <StepElement stepName="stepFour" css-class="lastStep" step-number="4"></StepElement>
      </a>
    </div>


  </div>

</template>

<script>
import {store} from "../../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import StepElement from "./StepElement.vue";

export default {
  name: "Steps",
  components: {StepElement},
  data() {
    return {
      store
    }
  },
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  methods: {
    goToStepOne() {
      if (!store.form.formSucceed) {
        this.store.form.steps.stepOne.filled = false;
        this.store.form.steps.stepOne.blurred = false;
        this.store.form.steps.stepTwo.filled = false;
        this.store.form.steps.stepThree.filled = false;
        this.store.goToStep('stepOne');
      }
    },
    goToStepTwo() {
      if (!store.form.formSucceed) {
        console.log('goToStepTwoEmit')
        if (this.store.form.currentStep === 'stepOne') {
          this.$emit("finishStepEmit", "stepTwo");
        }
        if (this.store.form.currentStep === 'stepThree') {
          this.store.form.steps.stepThree.filled = false;
          this.store.goToStep('stepTwo');
        }
        if (this.store.form.currentStep === 'stepFour') {
          this.store.form.steps.stepThree.filled = false;
          this.store.goToStep('stepTwo');
        }
      }

    },
    goToStepThree() {
      if (store.order.type === 'order' && !store.form.formSucceed) {
        console.log('goToStepThreeEmit')
        if (this.store.form.currentStep !== 'stepThree') {
          this.$emit("finishStepEmit", "stepThree");
        }
        if (this.store.form.currentStep === 'stepFour') {
          this.store.goToStep('stepThree');
        }
      }
    },
    goToStepFour() {
      if (store.order.type === 'order' && !store.form.formSucceed) {
        console.log('goToStepFourEmit')
        if (this.store.form.currentStep !== 'stepFour') {
          this.$emit("finishStepEmit", "stepFour");
        }
      }
    },
  }
}
</script>

<style type="scss" scoped>




</style>